var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgTwitter = function SvgTwitter(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 20,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.124 2.942c-.86.377-1.78.634-2.747.752A4.813 4.813 0 0 0 23.48 1.05c-.925.539-1.95.931-3.04 1.15A4.768 4.768 0 0 0 16.949.686a4.778 4.778 0 0 0-4.66 5.863A13.556 13.556 0 0 1 2.43 1.575a4.672 4.672 0 0 0-.647 2.402c0 1.66.846 3.118 2.127 3.975a4.775 4.775 0 0 1-2.166-.598v.06a4.78 4.78 0 0 0 3.836 4.683 4.866 4.866 0 0 1-2.15.083 4.798 4.798 0 0 0 4.476 3.315 9.605 9.605 0 0 1-5.933 2.043c-.379 0-.757-.022-1.137-.065a13.624 13.624 0 0 0 7.347 2.143c8.802 0 13.61-7.273 13.61-13.571 0-.203 0-.408-.015-.611a9.65 9.65 0 0 0 2.391-2.473l-.045-.02Z",
    fill: "#4F4F4F"
  })));
};

export default SvgTwitter;